module.exports = __webpack_public_path__ + "img/nature-49.d3ea2cd4.jpg";